var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-comment"},[(_vm.$pageType === 'entry')?_c('a',{attrs:{"href":_vm.linkUrl,"data-cx-clickarea":"comment-count-link"}},[_c('div',{staticClass:"count-comment"},[_c('span',[_vm._v(_vm._s(_vm.totalComment))])]),_vm._v(" "),_c('div',{staticClass:"read-comment"},[_vm._v("コメントを読む")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c572292","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/commentCountLink/commentCountLink.vue
// module id = null
// module chunks = 